import { cn } from "@/common/utils";

/**
 * The one canonical list-marker for the landing's feature/value lists: a
 * green check inside a faint green-tinted circle. Replaces the divergent
 * hand-drawn checkmarks (Use-cases @1.9 circled vs Pricing @1.5 bare) so the
 * whole page uses a single marker. `rounded-full` survives Steward's square
 * pass, so the circle stays a circle.
 */
export function CheckBullet({ className }: { className?: string }) {
  return (
    <span
      aria-hidden
      className={cn(
        "mt-0.5 flex size-4 shrink-0 items-center justify-center rounded-full",
        className,
      )}
      style={{
        backgroundColor: "color-mix(in srgb, var(--green) 14%, transparent)",
      }}
    >
      <svg className="size-2.5" viewBox="0 0 12 12" fill="none">
        <path
          d="M2.5 6.3 5 8.8 9.5 3.5"
          stroke="var(--green)"
          strokeWidth="1.75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </span>
  );
}
